import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useUtility, Stack, TextField, Text, Link, FeedbackBanner, Button } from '@hub-la/design-system';
import { useFormikContext, Form } from 'formik';
import { useTranslation } from 'react-i18next';
import { PermissionResource } from '../../domain/dtos/permissions-resources-enum.js';
import { PermissionField } from './permission-field.js';

const availablePermissions = [{
  name: 'permissions.home',
  value: PermissionResource.HOME,
  subpermissions: [{
    name: 'permissions.home_abandoned_checkout',
    value: PermissionResource.HOME_ABANDONED_CHECKOUT
  }]
}, {
  name: 'permissions.sales',
  value: PermissionResource.SALES
}, {
  name: 'permissions.products',
  value: PermissionResource.PRODUCTS,
  subpermissions: [{
    name: 'permissions.products_manage_co_production',
    value: PermissionResource.PRODUCTS_MANAGE_CO_PRODUCTION
  }, {
    name: 'permissions.products_manage_members',
    value: PermissionResource.PRODUCTS_MANAGE_MEMBERS
  }, {
    name: 'permissions.products_manage_post_comments',
    value: PermissionResource.PRODUCTS_MANAGE_POST_COMMENTS
  }]
}, {
  name: 'permissions.subscriptions',
  value: PermissionResource.SUBSCRIPTIONS,
  subpermissions: [{
    name: 'permissions.subscriptions_deactivate',
    value: PermissionResource.SUBSCRIPTIONS_DEACTIVATE
  }, {
    name: 'permissions.subscriptions_add_daily_credits',
    value: PermissionResource.SUBSCRIPTIONS_ADD_DAILY_CREDITS
  }]
}, {
  name: 'permissions.reports',
  value: PermissionResource.REPORTS
}, {
  name: 'permissions.clients',
  value: PermissionResource.CLIENTS
}, {
  name: 'permissions.affiliates',
  value: PermissionResource.AFFILIATES
}, {
  name: 'permissions.coupons',
  value: PermissionResource.COUPONS
}, {
  name: 'permissions.refunds',
  value: PermissionResource.REFUNDS
}, {
  name: 'permissions.financial',
  value: PermissionResource.WALLET
}, {
  name: 'permissions.integrations',
  value: PermissionResource.INTEGRATIONS
}];
const CollaboratorForm = ({
  loading,
  isEdit,
  error
}) => {
  var _a;
  const {
    t
  } = useTranslation();
  const {
    palette
  } = useUtility();
  const {
    handleChange,
    handleBlur,
    values,
    errors
  } = useFormikContext();
  return jsxs(Form, {
    children: [jsxs(Stack, Object.assign({
      gap: 6,
      mb: 10
    }, {
      children: [isEdit && jsx(TextField, {
        id: "name",
        type: "text",
        fullWidth: true,
        label: t('collaboratorForm.nameLabel'),
        onChange: handleChange,
        onBlur: handleBlur,
        value: values.name,
        error: Boolean(errors.name),
        helperText: errors.name && t(errors.name),
        disabled: isEdit
      }), jsx(TextField, {
        id: "email",
        type: "email",
        fullWidth: true,
        label: t('collaboratorForm.emailLabel'),
        onChange: handleChange,
        onBlur: handleBlur,
        value: values.email,
        error: Boolean(error) || Boolean(errors.email),
        helperText: (_a = error && t(error.message)) !== null && _a !== void 0 ? _a : errors.email && t(errors.email),
        disabled: isEdit
      }), jsxs(Stack, Object.assign({
        p: 6,
        bgcolor: palette('surfaceAt1'),
        borderRadius: 3
      }, {
        children: [jsx(Text, Object.assign({
          variant: "body1",
          fontWeight: 700,
          mb: 2
        }, {
          children: t('collaboratorForm.permissionsTitle')
        })), jsx(Link, Object.assign({
          mb: 4
        }, {
          children: jsx(Text, {
            children: t('collaboratorForm.permissionsHelpLink')
          })
        })), jsx(Stack, Object.assign({
          gap: 4
        }, {
          children: availablePermissions.map(permission => jsx(PermissionField, {
            name: t(permission.name),
            description: t('permissionsDescription.' + (permission === null || permission === void 0 ? void 0 : permission.value)),
            value: permission.value,
            subpermissions: permission === null || permission === void 0 ? void 0 : permission.subpermissions
          }, permission.value))
        }))]
      }))]
    })), error && jsx(FeedbackBanner, Object.assign({
      variant: "negative",
      my: 6
    }, {
      children: t(error.message)
    })), jsx(Stack, Object.assign({
      alignItems: "end",
      mt: 6
    }, {
      children: jsx(Button, Object.assign({
        type: "submit",
        size: "medium",
        loading: loading
      }, {
        children: t(isEdit ? 'collaboratorForm.updateButton' : 'collaboratorForm.submitButton')
      }))
    }))]
  });
};

export { CollaboratorForm };
